import * as React from 'react';
import {Element} from 'react-scroll';

export interface SimpleLinkProps {
    label?: string;
    id: string;
    className?: string;
    landing?: boolean;
    title?: string;
    text?: string;
}

export default class SimpleLinkComponent extends React.Component<SimpleLinkProps, any> {
  constructor(props: SimpleLinkProps) {
    super(props);
  }

  public render() {
    return (
        <div id={this.props.id} key={this.props.id} className={this.props.className + ' simple-link-container'}>
            <Element name={this.props.id}>
                {!this.props.landing && <>
                    <hr className="link-hr"/>
                    <h4 className="simple-link">
                        {this.props.label}
                    </h4>
                  </>
                }
                {this.props.landing && <div className="landing-simple-link">
                    <h2>
                      {this.props.title}
                    </h2>
                    <h4 className="simple-link">
                        {this.props.label}
                    </h4>
                    <hr className="link-hr"/>
                    <p>{this.props.text}</p>
                  </div>
                }
            </Element>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/simple-link.tsx